import { useEffect } from "react";

import StudentsManager from "../components/APanel/StudentsManager";
import GroupManager from "../components/APanel/GroupManager";
import PreloadAppData from "../components/Utils/PreloadAppData";
import Footer from "../components/Footer";

function MPanel() {
   useEffect(() => {
      document.title = "Instruire Auto | MPanel";
   }, []);

   return (
      <>
         <PreloadAppData />
         <main className="main">
            <section className="home-admin">
               <StudentsManager />
               <GroupManager />
            </section>

            <Footer />
         </main>
      </>
   );
}

export default MPanel;
